import React from 'react'

export const TimelineSectionSettings = () => {
  return (
    <div className="empty-message">
      <p>No options available</p>
    </div>
  )
}
